// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Quest_container__gg5lo {
  background-color: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 8px;
  padding: 16px;
  transition: all 0.2s linear;
}
.Quest_container__gg5lo .Quest_imgWrapper__Cct1Q {
  align-items: center;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  height: 200px;
  justify-content: center;
  transition: transform 0.5s;
}
.Quest_container__gg5lo .Quest_imgWrapper__Cct1Q:hover {
  transform: scale(1.07);
}
.Quest_container__gg5lo .Quest_chestTitleWrapper__RDq9m {
  border-bottom: 1px solid rgba(220, 220, 220, 0.1);
  margin-top: 18px;
  padding-bottom: 12px;
}
.Quest_container__gg5lo .Quest_chestTitleWrapper__RDq9m .Quest_chestTitle__I73oX {
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.Quest_container__gg5lo .Quest_chestTitleWrapper__RDq9m .Quest_chestTitle__I73oX .Quest_chestName__sBjch {
  font-size: 20px;
  font-weight: 700;
  font-style: normal;
  color: #ae6fff;
  height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.Quest_container__gg5lo .Quest_chestTitleWrapper__RDq9m .Quest_chestTitle__I73oX .Quest_chestStatus__Lbs4s {
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 20px;
}
.Quest_container__gg5lo .Quest_chestTitleWrapper__RDq9m .Quest_chestTitle__I73oX .Quest_chestStatusActive__4Atv9 {
  background-color: #11362c;
  color: #07ef9c;
}
.Quest_container__gg5lo .Quest_chestTitleWrapper__RDq9m .Quest_chestTitle__I73oX .Quest_chestStatusSoon__A5yum {
  background-color: #333217;
  color: #ead40c;
}
.Quest_container__gg5lo .Quest_chestTitleWrapper__RDq9m .Quest_chestTitle__I73oX .Quest_chestStatusCompleted__GzlCy {
  background-color: #351c1d;
  color: #f44336;
}
.Quest_container__gg5lo .Quest_questName__GIr8E {
  font-size: 24px;
  font-weight: 700;
  font-style: normal;
  color: #ffffff;
  font-size: 20px;
  margin-bottom: 12px;
  margin-top: 12px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.Quest_container__gg5lo .Quest_questTask__ZxJhO {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  color: #e0e0e0;
  height: 58px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.Quest_container__gg5lo .Quest_questTask__ZxJhO p:last-child {
  display: none;
}
.Quest_container__gg5lo .Quest_labels__sZr\\+t {
  display: flex;
  gap: 16px;
  margin-top: 16px;
}
.Quest_container__gg5lo .Quest_labels__sZr\\+t .Quest_label__HvBtR {
  border-radius: 8px;
  font-family: "Roboto";
  font-size: 16px;
  font-weight: 500;
  padding: 12px;
}
.Quest_container__gg5lo .Quest_labels__sZr\\+t .Quest_pm__L6N\\+B {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}
.Quest_container__gg5lo .Quest_labels__sZr\\+t .Quest_dota__e7ZVt {
  background-color: rgba(191, 46, 26, 0.15);
  color: #bf2e1a;
}
.Quest_container__gg5lo .Quest_btn__4K55R button {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  background-color: #fd4c0a;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 16px;
  padding-top: 12px;
  padding-bottom: 12px;
  transition: all 0.2s linear;
  width: 100%;
  color: #ffffff;
}
.Quest_container__gg5lo .Quest_btn__4K55R button:hover {
  transform: scale(1.02);
}

@media (max-width: 850px) {
  .Quest_container__gg5lo .Quest_questTask__ZxJhO {
    height: unset;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Quest/Quest.module.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAEA;EACE,oCAAA;EACA,kCAAA;EACA,kBAAA;EACA,aAAA;EACA,2BAAA;AADF;AAGE;EACE,mBAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,0BAAA;AADJ;AAGE;EACE,sBAAA;AADJ;AAIE;EACE,iDAAA;EACA,gBAAA;EACA,oBAAA;AAFJ;AAII;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;AAFN;AAIM;ECFJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDGM,cAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;AADR;AAIM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAFR;AAKM;EACE,yBAAA;EACA,cAAA;AAHR;AAMM;EACE,yBAAA;EACA,cAAA;AAJR;AAOM;EACE,yBAAA;EACA,cAAA;AALR;AAUE;EC/CA,eAAA;EACA,gBAAA;EACA,kBAAA;EDgDE,cAAA;EAEA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AARJ;AAWE;EClBA,eAAA;EACA,gBAAA;EACA,kBAAA;EDmBE,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AARJ;AAUI;EACE,aAAA;AARN;AAYE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AAVJ;AAYI;EACE,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AAVN;AAaI;EACE,0CAAA;EACA,WAAA;AAXN;AAcI;EACE,yCAAA;EACA,cAAA;AAZN;AAiBI;ECrEF,eAAA;EACA,gBAAA;EACA,kBAAA;EDsEI,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,2BAAA;EACA,WAAA;EACA,cAAA;AAdN;AAgBM;EACE,sBAAA;AAdR;;AAyBA;EAEI;IACE,aAAA;EAvBJ;AACF","sourcesContent":["@import \"../../assets/styles/global.scss\";\n\n.container {\n  background-color: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(0, 0, 0, 0);\n  border-radius: 8px;\n  padding: 16px;\n  transition: all 0.2s linear;\n\n  .imgWrapper {\n    align-items: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n    display: flex;\n    height: 200px;\n    justify-content: center;\n    transition: transform 0.5s;\n  }\n  .imgWrapper:hover {\n    transform: scale(1.07);\n  }\n\n  .chestTitleWrapper {\n    border-bottom: 1px solid rgba(220, 220, 220, 0.1);\n    margin-top: 18px;\n    padding-bottom: 12px;\n\n    .chestTitle {\n      align-items: center;\n      display: flex;\n      justify-content: space-between;\n\n      .chestName {\n        @include subtitle3b;\n\n        color: #ae6fff;\n        height: 24px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .chestStatus {\n        border-radius: 8px;\n        font-size: 14px;\n        font-weight: 500;\n        padding: 8px 20px;\n      }\n\n      .chestStatusActive {\n        background-color: #11362c;\n        color: #07ef9c;\n      }\n\n      .chestStatusSoon {\n        background-color: #333217;\n        color: #ead40c;\n      }\n\n      .chestStatusCompleted {\n        background-color: #351c1d;\n        color: #f44336;\n      }\n    }\n  }\n\n  .questName {\n    @include subtitle1b;\n\n    color: #ffffff;\n    // height: 50px;\n    font-size: 20px;\n    margin-bottom: 12px;\n    margin-top: 12px;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .questTask {\n    @include body1;\n\n    color: #e0e0e0;\n    height: 58px;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    p:last-child {\n      display: none;\n    }\n  }\n\n  .labels {\n    display: flex;\n    gap: 16px;\n    margin-top: 16px;\n\n    .label {\n      border-radius: 8px;\n      font-family: \"Roboto\";\n      font-size: 16px;\n      font-weight: 500;\n      padding: 12px;\n    }\n\n    .pm {\n      background-color: rgba(255, 255, 255, 0.1);\n      color: #fff;\n    }\n\n    .dota {\n      background-color: rgba(191, 46, 26, 0.15);\n      color: #bf2e1a;\n    }\n  }\n\n  .btn {\n    button {\n      @include subtitle6m;\n\n      background-color: #fd4c0a;\n      border-radius: 8px;\n      cursor: pointer;\n      margin-top: 16px;\n      padding-top: 12px;\n      padding-bottom: 12px;\n      transition: all 0.2s linear;\n      width: 100%;\n      color: #ffffff;\n\n      &:hover {\n        transform: scale(1.02);\n      }\n    }\n  }\n\n  // &:hover {\n  //   border: 1px solid;\n  //   transform: scale(1.02);\n  // }\n}\n\n@media (max-width: 850px) {\n  .container {\n    .questTask {\n      height: unset;\n    }\n  }\n}\n","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Quest_container__gg5lo`,
	"imgWrapper": `Quest_imgWrapper__Cct1Q`,
	"chestTitleWrapper": `Quest_chestTitleWrapper__RDq9m`,
	"chestTitle": `Quest_chestTitle__I73oX`,
	"chestName": `Quest_chestName__sBjch`,
	"chestStatus": `Quest_chestStatus__Lbs4s`,
	"chestStatusActive": `Quest_chestStatusActive__4Atv9`,
	"chestStatusSoon": `Quest_chestStatusSoon__A5yum`,
	"chestStatusCompleted": `Quest_chestStatusCompleted__GzlCy`,
	"questName": `Quest_questName__GIr8E`,
	"questTask": `Quest_questTask__ZxJhO`,
	"labels": `Quest_labels__sZr+t`,
	"label": `Quest_label__HvBtR`,
	"pm": `Quest_pm__L6N+B`,
	"dota": `Quest_dota__e7ZVt`,
	"btn": `Quest_btn__4K55R`
};
export default ___CSS_LOADER_EXPORT___;
